import * as React from "react";

function SvgYesterday(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M18 8L8 16l10 8V8zM20 8h3v16h-3z" fill="#fff" />
    </svg>
  );
}

export default SvgYesterday;
